

const UploadNFT = () => {
    return(
        <div className='bg-white dark:bg-dark-content-bg dark:text-white lg:ml-[250px] transition-colors duration-300 ease-in-out'>

            <div className="max-w-[1200px] mx-auto px-[5vw] lg:px-10 pb-20 pt-20">

                <div className="flex flex-col md:flex-row justify-between">
                    <div className="flex flex-col md:w-[65%]">
                        <p className='text-black dark:text-white font-medium text-base sm:text-lg mb-10'>
                            Upload Item
                        </p>
                        <div className="shadow-shadow2 border-[#eaecf3] dark:border-dark-nav-bg border-[1px] rounded-[7px] p-4 mb-10">
                            
                            <input type = 'file' className = 'w-full mb-5'/>

                            <label for = 'item-name' className="text-[#595959] dark:text-gray-400 font-medium text-base sm:text-lg mb-5">
                                Item Name
                            </label>
                            <input className="w-full px-3 bg-transparent py-2 rounded-[7px] border-[1px] border-gray-300 dark:border-dark-nav-bg mb-5" type = 'text' id = 'item-name'/>

                            <label for = 'description' className="text-[#595959] dark:text-gray-400 font-medium text-base sm:text-lg mb-5">
                                Description
                            </label>
                            <textarea className="w-full bg-transparent px-3 py-2 rounded-[7px] border-[1px] border-gray-300 dark:border-dark-nav-bg mb-5" type = 'text' id = 'description'></textarea>

                           <label for = 'royalities' className="text-[#595959] dark:text-gray-400 font-medium text-base sm:text-lg mb-5">
                                Royalities
                            </label>
                            <input className="w-full bg-transparent px-3 py-2 rounded-[7px] border-[1px] border-gray-300 dark:border-dark-nav-bg mb-5" type = 'text' id = 'royalities'/>

                           <label for = 'price' className="text-[#595959] dark:text-gray-400 font-medium text-base sm:text-lg mb-5">
                                Price
                            </label>
                            <input className="w-full bg-transparent px-3 py-2 rounded-[7px] border-[1px] border-gray-300 dark:border-dark-nav-bg mb-5" type = 'text' id = 'price'/>
                                                      
                        </div>
                    </div>

                    <div className="flex flex-col md:w-[30%]">
                        <p className='text-black dark:text-white font-medium text-base sm:text-lg mb-10'>
                            Preview
                        </p>
                        <div className="flex flex-col items-center md:items-start shadow-shadow2 border-[#eaecf3] dark:border-dark-nav-bg border-[1px] rounded-[7px] p-4">
                            <div className="w-full max-w-[400px] max-h-[400px] mb-5">
                                <img src = 'https://images.unsplash.com/photo-1518791841217-8f162f1e1131?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60' alt = 'item' 
                                    className = 'w-full h-full object-cover rounded-t-[10px] mb-5'/>
                            </div>
                            <h2 className="text-[#595959] dark:text-gray-400 font-medium text-base sm:text-lg mb-2">Afquid</h2>
                            <h2 className="text-[#595959] dark:text-gray-400 font-medium text-base sm:text-lg mb-2">Creator: <span className="text-main">FX44013x1</span></h2>
                            <h2 className="text-[#595959] dark:text-gray-400 font-medium text-base sm:text-lg">Price: <span className="text-main">0.004 ETH</span></h2>

                        </div>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default UploadNFT;